import { baseURL } from "./API_URL"

export const Baseurl = "https://cosmos.bajajfinservsecurities.in/franchisee-bo/api/bo"

export const Frenchisee = {
    REJECT_REASONS: Baseurl + "/master/reject-reasons",
    REJECTION_UPDATED: Baseurl + "/franchisee/status",
    GET_FRENCHISEE_ID: Baseurl + "/franchisee",
    GET_FRENCHISEE_DETAILS: Baseurl + "/franchisees",
    DELETE_FILE:Baseurl+"/file",
    GET_ALL_FILE:Baseurl+"/file",
    UPDATE_APPROVAL:Baseurl+"/franchisee"


}